
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import SopasScreen from './sopas';
import BebidasFriasScreen from './bebidasfrias';
import PolloBrasaScreen from './pollobrasa';
import CriollosScreen from './criollos';
import DesayunosScreen from './desayunos';
import BebidasCalientesScreen from './bebidascalientes';
import VegetarianosScreen from './vegetarianos';
import ChaufasScreen from './chaufas';
import SaltadosScreen from './saltados';
import CevicheScreen from './ceviche';
import SepecialMariscosScreen from './sepecialMariscos';
import TallarinesScreen from './tallarines';

function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [showSopas, setshowSopas] = useState(false);
    const [showBebidasFrias, setshowBebidasFrias] = useState(false);
    const [showPolloBrasa, setshowPolloBrasa] = useState(false);
    const [showCriollos, setshowCriollos] = useState(false);
    const [showDesayunos, setshowDesayunos] = useState(false);
    const [showBebidasCalientes, setshowBebidasCalientes] = useState(false);
    const [showVegetarianos, setshowVegetarianos] = useState(false);
    const [showChaufas, setshowChaufas] = useState(false);
    const [showSaltados, setshowSaltados] = useState(false);
    const [showCeviche, setshowCeviche] = useState(false);
    const [showSepecialMariscos, setshowSepecialMariscos] = useState(false);
    const [showTallarines, setshowTallarines] = useState(false);


     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 345,
                 maxHeight: 345,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                borderRadius: 30,
                padding: 20,
                boxSizing: "border-box",
                display: 'flex',
                flexDirection: 'column'
            }}>
                <img src={image} onContextMenu={(e) => e.preventDefault()} style={{width: 305, height: 265, objectFit: 'cover',   pointerEvents: 'none',  borderRadius: 30,}}/>
                <h3 style={
                    { fontFamily: "BebasNeue", color: 'black', textTransform: 'uppercase', fontSize: 22, fontWeight: '500',margin: 0, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '80%', margin: '0 auto'}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: 'BebasNeue',fontSize: 15, color: '#6D6D6D', textAlign: 'center', margin: 0,}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showLamp={ false}  goCategories={setshowCategories} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div style={{
                    background: 'white',
                    width: '92%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '10px 10px',
                    gap: 10,
                    justifyContent: 'space-between',
                    overflow: 'scroll',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 14
                }}>
                    {menusData.map((item, key) => {
                            if (![443, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: 'linear-gradient(90deg, #F93C36 0%, #92080B 100%)',

                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '5px 15px',
                                     borderRadius: 14
                            }}
                                    onClick={() => { 
                                        if(item.id === 514) {
                                            setshowSopas(true)
                                        } else if(item.id === 509) {
                                            setshowBebidasFrias(true)
                                        } else if(item.id === 513) {
                                            setshowPolloBrasa(true)
                                        } else if(item.id === 504) {
                                            setshowCriollos(true)
                                        } else if(item.id === 506) {
                                            setshowDesayunos(true)
                                        } else if(item.id === 516) {
                                            setshowBebidasCalientes(true)
                                        } else if(item.id === 508) {
                                            setshowVegetarianos(true)
                                        } else if(item.id === 454) {
                                            setshowChaufas(true)
                                        } else if(item.id === 510) {
                                            setshowSaltados(true)
                                        } else if(item.id === 512) {
                                            setshowCeviche(true)
                                        } else if(item.id === 511) {
                                            setshowSepecialMariscos(true)
                                        } else if(item.id === 456) {
                                            setshowTallarines(true)
                                        } else {
                                            setMenus(item.menus)
                                    }
                                    
                                }}
                                >
                                <p className='shor-text' style={{color: 'white', fontWeight: "900",fontSize: 15}}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>
                <div >
                    <div style={{
                       
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 10px 100px 10px',
                            height: 605,
                            overflow: 'scroll',
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                {showBebidasFrias && <BebidasFriasScreen setShowBuffet={setshowBebidasFrias} />}
                {showPolloBrasa && <PolloBrasaScreen setShowBuffet={setshowPolloBrasa} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showCriollos && <CriollosScreen setShowBuffet={setshowCriollos} />}
                {showDesayunos && <DesayunosScreen setShowBuffet={setshowDesayunos} />}
                {showBebidasCalientes && <BebidasCalientesScreen setShowBuffet={setshowBebidasCalientes} />}
                {showVegetarianos && <VegetarianosScreen setShowBuffet={setshowVegetarianos} />}
                {showChaufas && <ChaufasScreen setShowBuffet={setshowChaufas} />}
                {showSaltados && <SaltadosScreen setShowBuffet={setshowSaltados} />}
                {showCeviche && <CevicheScreen setShowBuffet={setshowCeviche} />}
                {showSepecialMariscos && <SepecialMariscosScreen setShowBuffet={setshowSepecialMariscos} />}
                {showTallarines && <TallarinesScreen setShowBuffet={setshowTallarines} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;